export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const MODAL_OPEN = "modal-OPEN";
export const MODAL_CLOSE = "modal-CLOSE";


// WEBPACK FOOTER //
// ./src/ducks/ui/constants.js